import { PageWithLayout } from '@/pages/_app';
import { Helmet } from 'react-helmet-async';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { CouponPageContent } from '@/pageContents/couponsContent/CouponPageContent';
import { Permission } from '@/models/user';

const CouponPage: PageWithLayout = () => {
    return (
        <>
            <Helmet>Coupons | Starjack Backoffice</Helmet>

            <CouponPageContent />
        </>
    );
};

CouponPage.isProtected = true;
CouponPage.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;
CouponPage.permissions = [Permission.ADMIN];

export default CouponPage;
